module.exports = __webpack_public_path__ + "static/img/index-sp-3.5aed252.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index-sp-3.jpg
// module id = Y1MQ
// module chunks = 0